import { Component, OnInit, Injector } from '@angular/core';
import { MatFormFieldModule, MatDialogRef } from '@angular/material';
import { ValidationErrors } from '@angular/forms';

import { ContactService } from '../../services/contact.service';
import { NotificationService } from '../../services/notification.service';

@Component({
  selector: 'app-quoterequest',
  templateUrl: './quoterequest.component.html',
  styleUrls: ['./quoterequest.component.css']
})
export class QuoterequestComponent implements OnInit {
  data: any = {};

  notifier = this.injector.get(NotificationService);
  constructor(private _contactservice: ContactService,private injector: Injector,public dialogRef: MatDialogRef<QuoterequestComponent>) { }

  ngOnInit() {
    this.data.interest = "Web design & development";
  }


  onSubmit() {
    this._contactservice.quoteRequest(this.data).subscribe(data => this.data = data,error => this.notifier.showError(error.message),() => {this.notifier.showSuccess(" Quote Requested");});
    this.dialogRef.close();
    //alert(JSON.stringify(this.data));
  }

  getErrorMsg(ftype: string, err: ValidationErrors ){
      var msg: string = "";
      
      switch(ftype){
          case "name":{
            if(err.required){
              msg = "Name is required!";
            }
            else
            {
              msg = "Name is Invalid!";
            }
            break;
          }
          case "email":{
            if(err.required){
            msg = "Email is required!"
            }
            else
            {
              msg = "Email address is Invalid!";
            }
            break;
          }

      }
      return msg;
  }
}
